<template>
  <el-dialog
    :title="$t('message.selectMaintainedTag')"
    :visible.sync="visible"
    width="90%"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="history-table">
      <div class="history-row history-head">
        <span>{{ $t('message.warehouseType') }}</span>
        <span>{{ $t('message.commodityManagementCode') }}</span>
        <span>{{ $t('message.tagCoding') }}</span>
        <span>{{ $t('message.labelText') }}1</span>
        <span>{{ $t('message.labelText') }}2</span>
        <span>{{ $t('message.labelText') }}3</span>
        <span>{{ $t('message.labelText') }}4</span>
        <span>{{ $t('message.operation') }}</span>
      </div>
      <div class="history-row" v-for="(item, index) in list" :key="index">
        <span>{{ tagTypeLabel(item.type) }}</span>
        <span>{{ item.goods_no }}</span>
        <span>{{ item.no }}</span>
        <span>{{ item.text_line_one }}</span>
        <span>{{ item.text_line_two }}</span>
        <span>{{ item.text_line_three }}</span>
        <span>{{ item.text_line_four }}</span>
        <span>
          <el-button type="primary" size="mini" @click="choose(item)">{{ $t('message.choose') }}</el-button>
        </span>
      </div>
      <div class="empty-block" v-if="!list.length">{{ $t('message.noMaintainedTag') }}</div>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 已维护标签选择弹框
 * 数据来源为当前商品详情中的 client_product_tag（商品标签管理已保存的标签）
 */
export default {
  name: 'MaintainedTagDialog',
  data() {
    return {
      visible: false, // 弹框显隐
      list: [], // 已维护标签列表
      // 仓库类型枚举，用于 type 转中文展示
      tagList: [
        { label: '亚马逊FBA', value: 'FBA' },
        { label: '乐天', value: 'LETIAN' },
        { label: '雅虎', value: 'YAHU' },
        { label: 'ZOZO', value: 'ZOZO' },
        { label: '其他', value: '其他' }
      ]
    }
  },
  methods: {
    /**
     * 打开弹框
     * @param {Array} tagList 商品已维护标签（client_product_tag）
     */
    open(tagList) {
      this.list = tagList || []
      this.visible = true
    },
    // type 编码转展示文案
    tagTypeLabel(type) {
      const item = this.tagList.find(tag => tag.value === type)
      return item ? item.label : type
    },
    /**
     * 选择一条已维护标签，回传给创建方案表单
     * @param {Object} item 已维护标签
     */
    choose(item) {
      this.$emit('confirm', {
        type: item.type,
        no: item.no,
        goods_no: item.goods_no,
        code_type: item.code_type || 'CODE128',
        text_line_one: item.text_line_one,
        text_line_two: item.text_line_two,
        text_line_three: item.text_line_three,
        text_line_four: item.text_line_four
      })
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.history-table {
  max-height: 460px;
  overflow: auto;
}

.history-row {
  display: grid;
  min-width: 1380px;
  grid-template-columns: 1fr 1.2fr 1.4fr repeat(4, 1.4fr) 0.8fr;
  gap: 8px;
  padding: 10px 0;
  border-bottom: 1px solid #EEEEEE;
  font-size: 14px;

  &.history-head {
    font-weight: bold;
    color: #333333;
  }
}

.empty-block {
  padding: 24px 0;
  color: #999999;
  text-align: center;
}
</style>
